import formatMoney from '@ott/utility-format-money';

const CURRENCIES_DICT = {
  UAH: 'UAH',
  KZT: 'KZT',
  GBP: 'GBP',
  USD: 'USD',
  EUR: 'EUR',
  TRY: 'TRY',
  PLN: 'PLN',
  RUB: 'RUB',
  BYN: 'BYN',
  CHF: 'CHF',
  UZS: 'UZS',
};

function formatDatepickerPrice(amount, currency = CURRENCIES_DICT.RUB) {
  if (typeof amount !== 'number') return '';

  let isPriceShortened = false;
  let preparedAmount = amount;

  if (currency !== CURRENCIES_DICT.RUB && amount > 999) {
    isPriceShortened = true;
    preparedAmount = amount / 1000;
  }

  let maximumFractionDigits;
  if (isPriceShortened) {
    maximumFractionDigits = 1;
  } else if ([CURRENCIES_DICT.RUB, CURRENCIES_DICT.UAH].includes(currency)) {
    // рубли и гривны указываются без копеек
    maximumFractionDigits = 0;
  } else {
    maximumFractionDigits = 2;
  }

  let formattedAmount = formatMoney(preparedAmount, {
    currencyCode: currency,
    asNumber: true,
    numberFormatOptions: {
      minimumFractionDigits: 0,
      maximumFractionDigits,
    },
  });

  if (isPriceShortened) {
    formattedAmount += 'k';
  }

  return formattedAmount;
}

export default formatDatepickerPrice;
